if (!customElements.get('featured-collection-slider')) {
  class FeaturedCollectionSlider extends HTMLElement {
    selectors = {
      slider: '[js-slider]',
      prev: '[js-prev]',
      next: '[js-next]',
      pagination: '[js-pagination]',
    };

    config = {
      slidesPerView: 'auto',
      slidesPerGroup: 2,
      spaceBetween: 12,
    };

    constructor() {
      super();
    }

    // Calculates the pagination progress element's width based on the currently visible slides
    handleIntersection(entries) {
      this.slideWidthPercent = 100.0 / this.swiperInstance.slides.length;

      const elements = entries.filter((entry) => entry.isIntersecting);
      if (!elements.length) return;
      // Last intersecting element
      const element = elements[elements.length - 1].target;
      // Ternary operator fixes an issue where scrolling after the last element
      // gives an intersection with the second to last element.
      // Indexes start at 1
      const elementIndex1 =
        this.swiperInstance.progress == 1
          ? this.swiperInstance.slides.length
          : Number(element.getAttribute('aria-label').split(' /')[0]);

      // Calculates the width based on the last visible slide times the percentage
      // width of a single slide
      let width = elementIndex1 * this.slideWidthPercent;
      // Add minimum width, fixing a issue when returning back to the 1st element
      if (!this.minWidth) this.minWidth = width;
      if (this.minWidth && width < this.minWidth) width = this.minWidth;

      this.paginationElement.style.setProperty('--width', width + '%');
    }

    init() {
      this.paginationElement = this.querySelector(this.selectors.pagination);

      let slidesDesktop =
        this.getAttribute('data-slides-per-view-desktop') ?? 6;
      let slidesPerGroup =
        this.getAttribute('data-slides-per-group-desktop') ??
        this.getAttribute('data-slides-per-view-desktop') ??
        6;

      if (window.location.pathname.includes('/account')) {
        slidesDesktop = 4;
        slidesPerGroup = 4;
      }

      this.swiperInstance = new Swiper(
        this.querySelector(this.selectors.slider),
        {
          ...this.config,
          breakpoints: {
            1050: {
              slidesPerView: Number(slidesDesktop),
              slidesPerGroup: Number(slidesPerGroup),
            },
          },
          navigation: {
            prevEl: this.querySelector(this.selectors.prev),
            nextEl: this.querySelector(this.selectors.next),
          },
          pagination: {
            el: this.paginationElement,
            type: 'progressbar',
          },
        },
      );

      let options = {
        root: this.sliderElement,
        rootMargin: '0px',
        threshold: 1.0,
      };

      let observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        options,
      );

      this.swiperInstance.slides.forEach((slide) => {
        observer.observe(slide);
      });
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(this.selectors.slider);

      if (!this.sliderElement) return;

      window.setTimeout(() => {
        if (!this.hasAttribute('js-await-init')) this.init();
      }, 200);

      this.addEventListener(
        'featured-collection-slider:init',
        this.init.bind(this),
      );
    }
  }

  customElements.define('featured-collection-slider', FeaturedCollectionSlider);
}
